// src/components/EditBookModal.js
import React, { useState, useEffect } from 'react';

const EditBookModal = ({ book, onSave, onClose }) => {
  const [title, setTitle] = useState(book?.title || '');
  const [rating, setRating] = useState(book?.rating || '');
  const [comments, setComments] = useState(book?.comments || '');
  const [date, setDate] = useState('');
  const [coverUrl, setCoverUrl] = useState(book?.coverUrl || '');

  useEffect(() => {
    if (book?.date) {
      const d = new Date(book.date);
      setDate(d.toISOString().split('T')[0]);
    }
  }, [book]);

  const handleSubmit = (e) => {
    e.preventDefault();
    onSave({
      title,
      rating: parseInt(rating, 10) || 0,
      comments,
      date,
      coverUrl
    });
  };

  if (!book) return null;

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-content" onClick={e => e.stopPropagation()}>
        <h3>Edit Book</h3>
        <form onSubmit={handleSubmit}>
          <label>
            Title
            <input
              type="text"
              value={title}
              onChange={e => setTitle(e.target.value)}
              required
            />
          </label>
          <label>
            Rating (1-5)
            <input
              type="number"
              min="1"
              max="5"
              value={rating}
              onChange={e => setRating(e.target.value)}
            />
          </label>
          <label>
            Comments
            <textarea
              value={comments}
              onChange={e => setComments(e.target.value)}
              rows={3}
            />
          </label>
          <label>
            Date
            <input
              type="date"
              value={date}
              onChange={e => setDate(e.target.value)}
            />
          </label>
          <label>
            Cover URL (optional)
            <input
              type="url"
              value={coverUrl}
              onChange={e => setCoverUrl(e.target.value)}
              placeholder="https://..."
            />
          </label>
          <div className="modal-buttons">
            <button type="button" onClick={onClose} className="cancel-btn">Cancel</button>
            <button type="submit">Save</button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default EditBookModal;
